<template>
	<div class="wrapper">
		<div class="animated fadeIn">
			<b-row>
				<b-col cols="12">
					<b-card header-tag="header">
						<div slot="header"><i class="icon-layers"></i> Provident Fund Settings</div>
						<div class="d-flex flex-row mb-5">
							<div class="col-2">
								Select Office
							</div>
							<div class="col-6">
								<multiselect v-model="office" @input="getOfficePfConfig()"
														 :options="officeList"
														 :close-on-select="true"
														 :searchable="true"
														 label="name"
														 placeholder="Pick a value"></multiselect>
							</div>
						</div>
						<div class="d-flex flex-row mb-5">
							<div class="col-2">
								Accounting starting month
							</div>
							<div class="col-6">
								<multiselect v-model="accountingYearStartMonth"
														 :options="months"
														 :close-on-select="true"
														 :searchable="true"
														 :show-labels="false"
														 placeholder="Pick a Month"></multiselect>
							</div>

						</div>
						<div class="d-flex flex-row mb-5">
							<div class="col-2"></div>
							<div class="col-6">
								<b-form-checkbox v-model="interestDistributableToAll"
																 name="interestDistributableToAll"
																 id="interestDistributableToAll"
																 switch
								>
									Distribute interest to separated members
								</b-form-checkbox>
							</div>

						</div>
						<div class="d-flex flex-row  mb-5">
							<div class="col-8 d-flex justify-content-end" v-if="$store.getters.canWrite">
								<b-button variant="success" @click="savePFSettings()"><i
									class="fa fa-save"></i> Save
								</b-button>
							</div>

						</div>
					</b-card>
				</b-col>
			</b-row>
		</div>
	</div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import officeService from '@/services/officeService'
import toastService from '@/services/toastService'
import officePfConfigService from "@/services/officePfConfigService";

export default {
	name: 'modules',
	components: {Multiselect},
	data() {
		return {
			officePfConfigId: null,
			office: "",
			months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
			accountingYearStartMonth: "",
			officeList: [],
			interestDistributableToAll: false,
		}
	},
	methods: {
		savePFSettings() {
			if (this.office == "") {
				toastService.showErrorToast("Please select an office");
				return;
			}else if (this.accountingYearStartMonth === "" || !this.accountingYearStartMonth) {
				toastService.showErrorToast("Please select an accounting year start month");
				return;
			}
			let request = {
				officeId: this.office.id,
				accountingYearStartMonth: this.accountingYearStartMonth?this.months.indexOf(this.accountingYearStartMonth)+1:"",
				interestDistributableToAll: this.interestDistributableToAll? this.interestDistributableToAll:false
			}

			if(this.officePfConfigId){
				request.id = this.officePfConfigId;
			}
			officePfConfigService.saveOfficePfConfig(request, r =>{
				toastService.showSuccessToast("Update Successful");
				},e =>toastService.showErrorToast(e)
			);
		},
		getOfficePfConfig(){
			if (this.office == "" || !this.office) {
				return;
			}
			officePfConfigService.getOfficePfConfigList(this.office.id, r => {
				this.officePfConfigId = r.id
				this.accountingYearStartMonth = this.months[r.accountingYearStartMonth-1];
				this.interestDistributableToAll = r.interestDistributableToAll;
			}, e => {
				toastService.showErrorToast(e);
			})
		}
	},
	mounted() {
		officeService.getOfficeListForProvidentFund(r => this.officeList = r, e => toastService.showErrorToast(e));
	}
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
